import { OnInit, OnDestroy } from '@angular/core';
import { Router } from "@angular/router";
import { AuthService } from "../../login/services/auth.service";
import { DacConfig } from "../../shared/services/dac-config.service";
import { NavBarService } from 'app/theme/services/nav-bar.service';
var NavbarComponent = /** @class */ (function () {
    function NavbarComponent(authService, dacConfig, router, navService) {
        var _this = this;
        this.authService = authService;
        this.dacConfig = dacConfig;
        this.router = router;
        this.navService = navService;
        this._navItems = [];
        this.authService.getLoginState().subscribe(function (state) {
            var items = _this.navService.topNavBarItemsForDisplay;
            if (items && items.length) {
                _this._navItems = items;
            }
            else {
                _this._navItems = [];
            }
        });
    }
    NavbarComponent.prototype.ngOnInit = function () {
    };
    NavbarComponent.prototype.ngOnDestroy = function () {
        // TODO: stephen this is a hack to cleanup after the MDB-navbar whenever we logout
        // we need to remove the fixed piece.
        var element = document.querySelector("body.fixed-sn");
        if (element) {
            element.classList.remove("fixed-sn");
        }
    };
    Object.defineProperty(NavbarComponent.prototype, "navItems", {
        get: function () {
            return this._navItems;
        },
        enumerable: true,
        configurable: true
    });
    NavbarComponent.prototype.toggleSideNav = function () {
        this.navService.toggleSidebar();
    };
    NavbarComponent.prototype.handleItemClick = function (item, $event) {
        this.navService.handleMenuItemClick(item, $event);
    };
    Object.defineProperty(NavbarComponent.prototype, "navClassString", {
        get: function () {
            var navBarString = this.dacConfig.navBarClass;
            if (this.doubleNav) {
                return navBarString + " navbar fixed-top navbar-expand-sm double-nav";
            }
            else {
                return navBarString + " navbar navbar-expand-sm";
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavbarComponent.prototype, "containerInside", {
        get: function () {
            if (this.doubleNav) {
                return false;
            }
            else {
                return true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavbarComponent.prototype, "logoUrl", {
        get: function () {
            return this.dacConfig.applicationLogoUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavbarComponent.prototype, "logoTitle", {
        get: function () {
            return this.dacConfig.applicationLogoTitle;
        },
        enumerable: true,
        configurable: true
    });
    return NavbarComponent;
}());
export { NavbarComponent };



// WEBPACK FOOTER //
// ./src/app/theme/navbar/navbar.component.ts.pre-build-optimizer.js